import Vue from 'vue';
import wysiwyg from 'vue-wysiwyg';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import VueFlashMessage from 'vue-flash-message';
import VueScrollTo from 'vue-scrollto';
import VueGoodTablePlugin from 'vue-good-table';
import SweetModal from 'sweet-modal-vue/src/plugin';
import VuePromiseBtn from 'vue-promise-btn';
import zoom from 'vue-image-zoom';
import DadataSuggestions from 'vue-dadata-suggestions';
import PerfectScrollbar from 'vue2-perfect-scrollbar';

import apiClient from '@/apiClient';
import App from './App.vue';
import router from './router';
import store from './store/store';

// Filters
import formatDateFilter from '@/filters/format-date.filter';
import toVerbalDateFilter from '@/filters/to-verbal-date.filter';
import dimensionsFilter from '@/filters/dimensions.filter';
import toPercentFilter from '@/filters/toPercent.filter';
import floatFilter from '@/filters/float.filter';

// Stylesheets
import './assets/scss/main.scss';
import 'vue-flash-message/dist/vue-flash-message.min.css';
import 'vue-good-table/dist/vue-good-table.css';
import 'flatpickr/dist/flatpickr.css';
import 'vue-wysiwyg/dist/vueWysiwyg.css';
import 'flatpickr/dist/themes/material_blue.css';
import 'vue-promise-btn/dist/vue-promise-btn.css';
import 'vue-image-zoom/dist/vue-image-zoom.css';
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';

// Localize
require('./localize');

// Validation
require('./validators/main');
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

Vue.use(VueScrollTo);
Vue.use(VueGoodTablePlugin);
Vue.use(SweetModal);
Vue.use(VuePromiseBtn);
Vue.use(VueFlashMessage, {
  messageOptions: {
    timeout: 4000
  }
});

// WYSIWYG editor config
Vue.use(wysiwyg, {
  hideModules: {
    underline: true,
    code: true,
    image: true
  }
});

// Filters
Vue.filter('formatDate', formatDateFilter);
Vue.filter('toVerbalDate', toVerbalDateFilter);
Vue.filter('dimensions', dimensionsFilter);
Vue.filter('toPercent', toPercentFilter);
Vue.filter('float', floatFilter);

// DaData
Vue.use(DadataSuggestions, {
  token: 'f776dc4860af921dee7def66d4b23349c17309a6',
  type: 'ADDRESS'
});

// OTHER
Vue.use(zoom);
Vue.use(PerfectScrollbar);

Vue.config.productionTip = false;

// eslint-disable-next-line no-new

const vueInit = () =>
  new Vue({
    router,
    store,
    created() {
      if (this.$store.getters.isLoggedIn) {
        const { id: firmId, isAdmin } = this.$store.state.user.profile;

        if (!isAdmin) {
          Promise.all([
            this.$store.dispatch('setConnectionWithSocket', firmId),
            this.$store.dispatch('getTimezonesList'),
            this.$store.dispatch('getUserBalance', firmId),
            this.$store.dispatch('userStatsRequest'),
            // this.$store.dispatch('completeTutorial'),
            this.$store.dispatch('getNotifications'),
            this.$store.dispatch('packagesGet')
          ]).then(() => {
            this.$mount('#app');
          });
        } else {
          Promise.all([
            this.$store.dispatch('setConnectionWithSocket', firmId),
            this.$store.dispatch('getTimezonesList'),
            this.$store.dispatch('getNotifications'),
            this.$store.dispatch('packagesGet')
          ]).then(() => {
            this.$mount('#app');
          });
        }
      } else {
        this.$mount('#app');
      }
    },
    render: h => h(App)
  });

if (store.getters.isLoggedIn) {
  store
    .dispatch('userRequest')
    .then(() => {
      vueInit();
    })
    .catch(() => {
      alert('Не удалось загрузить данные');

      localStorage.removeItem('access_token');
      delete apiClient.defaultConfig.headers.Authorization;

      store.commit('logout');
      vueInit();
    });
} else {
  store.commit('setUserEntryUrl', window.location.href.replace(/.+app/, ''));
  vueInit();
}
